import React, { useEffect, useState } from 'react';
import { Spin } from 'antd'
import { MenuOutlined ,CloseOutlined} from '@ant-design/icons';
import './Admin.css';

import AdminLogin from '../AdminComponent/Adminlogin.js/Adminlogin';
import AdminSignup from '../AdminComponent/Adminsignup/Adminsignup';
import AddStation from '../AdminComponent/AddCategory/Addstations';
import AddBus from '../AdminComponent/AddBuses/AddBus';
import AdminStata from '../AdminComponent/Users/AdminStata';
import UserData from '../AdminComponent/UserData/UserData';



function Admin() {
  
  // let admintToken = localStorage.getItem("admintoken");
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem("admintoken"));
  const [loading, setLoading] = useState(false); // State for loading spinner
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [adminScreen, setAdminScreen] = useState("dashboard")
  // const [icon, setAdminScreen] = useState("dashboard")




  useEffect(() => {
    setIsLoggedIn(localStorage.getItem("admintoken"));
  }, [isLoggedIn]);


  const handeladmninLogout = () => {

    localStorage.removeItem("admintoken");

    setIsLoggedIn("changed")
  }







  const toogleScreen = (screen) => {
    setAdminScreen(screen)
  }



  const [isFlipped, setIsFlipped] = useState(false);

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  const setLoad = (newState) => {
    setLoading(newState);
  };


  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };








  return (
    <>
      {!isLoggedIn ? (
        <div className="adminCredentials">
          <Spin spinning={loading}>
              <div className="auth-container max-w-md mx-auto p-4">
                <div className={`card relative ${isFlipped ? "flipped" : ""}`}>
                  <div className="card-front">
                    <AdminLogin
                      onFlip={handleFlip}
                      setIsLoggedIn={setIsLoggedIn}
                      setLoad={setLoad}
                      loading={loading}
                    />
                    
                  </div>
                  <div className="card-back absolute inset-0">
                    <AdminSignup onFlip={handleFlip} setLoad={setLoad} loading={loading} />
                  </div>
                </div>
              </div>
            </Spin>

        </div>
      ) : (
        <div className="Admin min-h-screen flex flex-col">
          {/* Header */}
          <header className="header bg-blue-500 text-white p-4 flex justify-between items-center shadow-md">
            <h1 className="text-lg md:text-xl font-bold">Admin Panel</h1>
            <button
              onClick={handeladmninLogout}
              className="bg-red-500 px-3 py-1 rounded hover:bg-red-600 transition"
            >
              Log-out
            </button>
          </header>

          {/* Main Container */}
          <div className="flex flex-1 flex-col md:flex-row">
            {/* Sidebar */}
          




            <button
              onClick={toggleSidebar}
              className="p-2 text-white bg-blue-500 w-8 z-50 md:hidden visible"
            >
            {!isSidebarOpen?  <MenuOutlined/>:
              <CloseOutlined/>}
            </button>

            {/* Sidebar */}
            <aside
              className={`sidebar bg-gray-100 p-4 shadow-lg transition-transform duration-300 ease-in-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
                } md:translate-x-0 md:w-1/4 h-screen fixed md:relative z-40`}
            >
              <nav>
                <ul className="sidenav-ul space-y-4">
                  <li
                    className="cursor-pointer hover:text-blue-500 transition"
                    onClick={() => {
                      toggleSidebar(); // Optionally collapse sidebar on click
                      toogleScreen('dashboard');
                    }}
                  >
                    Dashboard
                  </li>
                  <li
                    className="cursor-pointer hover:text-blue-500 transition"
                    onClick={() => {
                      toggleSidebar(); // Optionally collapse sidebar on click
                      toogleScreen('user');
                    }}
                  >
                    User
                  </li>
                  <li
                    className="cursor-pointer hover:text-blue-500 transition"
                    onClick={() => {
                      toggleSidebar(); // Optionally collapse sidebar on click
                      toogleScreen('station');
                    }}
                  >
                    Add Station
                  </li>
                  <li
                    className="cursor-pointer hovher:text-blue-500 transition"
                    onClick={() => {
                      toggleSidebar(); // Optionally collapse sidebar on click
                      toogleScreen('addBus');
                    }}
                  >
                    Add Bus
                  </li>
                  
                </ul>
              </nav>
            </aside>


            {/* Content Area */}
            <div className="content-area flex-1 p-4 bg-gray-400">
              {adminScreen === "dashboard" && <AdminStata />}
              {adminScreen === "station" && <AddStation />}
              {adminScreen === "addBus" && <AddBus />}
              {adminScreen === "user" && <UserData />}
            </div>
          </div>
        </div>
      )}
    </>


  )
}

export default Admin